import {
  CATEGORY_BYID_LIST,
  CATEGORY_LIST,
  CATEGORY_LIST_LOADER,
} from "../actions/type";

const initialState = {
  categoryList: {},
  categoryListLoader: false,
  categoryListById: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CATEGORY_LIST:
      return {
        ...state,
        categoryList: payload,
        categoryListLoader: false,
      };

    case CATEGORY_LIST_LOADER:
      return {
        ...state,
        categoryListLoader: payload,
      };

    case CATEGORY_BYID_LIST:
      return {
        ...state,
        categoryListById: payload,
      };

    default:
      return state;
  }
}
